

// import React, { useState, useEffect } from 'react';
// import { getDatabase, ref, get, update } from 'firebase/database';
// import { 
//     Box, 
//     Paper, 
//     Typography, 
//     Grid, 
//     Card, 
//     CardContent, 
//     TextField, 
//     Button, 
//     Divider,
//     Chip,
//     Alert
// } from '@mui/material';
// import { toast } from 'react-toastify';

// const database = getDatabase();

// const PatientDetails = ({ appointmentId, doctorId }) => {
//     const [appointment, setAppointment] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [prescription, setPrescription] = useState('');
//     const [savingPrescription, setSavingPrescription] = useState(false);

//     useEffect(() => {
//         fetchAppointmentDetails();
//     }, [appointmentId, doctorId]);

//     const fetchAppointmentDetails = async () => {
//         try {
//             setLoading(true);
//             console.log('🔍 Fetching appointment details:', appointmentId);

//             const appointmentRef = ref(database, `doctor/${doctorId}/appointments/${appointmentId}`);
//             const snapshot = await get(appointmentRef);

//             if (snapshot.exists()) {
//                 const appointmentData = snapshot.val();
//                 console.log('✅ Appointment data loaded:', appointmentData);
                
//                 setAppointment(appointmentData);
//                 setPrescription(appointmentData.prescription || '');
//             } else {
//                 console.error('❌ Appointment not found');
//                 toast.error('Appointment not found');
//             }
//         } catch (error) {
//             console.error('❌ Error fetching appointment:', error);
//             toast.error('Failed to load appointment details');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSavePrescription = async () => {
//         if (!prescription.trim()) {
//             toast.error('Please enter prescription details');
//             return;
//         }

//         setSavingPrescription(true);

//         try {
//             const updates = {
//                 prescription: prescription.trim(),
//                 prescriptionDate: new Date().toISOString(),
//                 updatedAt: new Date().toISOString()
//             };

//             const doctorAppointmentRef = ref(database, `doctor/${doctorId}/appointments/${appointmentId}`);
//             await update(doctorAppointmentRef, updates);

//             if (appointment.patientID) {
//                 const patientAppointmentRef = ref(database, `users/${appointment.patientID}/appointments/${appointmentId}`);
//                 await update(patientAppointmentRef, updates);
//             }

//             toast.success('Prescription saved successfully');
//             setAppointment(prev => ({ ...prev, ...updates }));
//         } catch (error) {
//             console.error('Error saving prescription:', error);
//             toast.error('Failed to save prescription');
//         } finally {
//             setSavingPrescription(false);
//         }
//     };

//     const handleCompleteAppointment = async () => {
//         if (!prescription.trim()) {
//             toast.error('Please add prescription before completing appointment');
//             return;
//         }

//         try {
//             const updates = {
//                 status: 'Completed',
//                 completedAt: new Date().toISOString(),
//                 updatedAt: new Date().toISOString()
//             };

//             const doctorAppointmentRef = ref(database, `doctor/${doctorId}/appointments/${appointmentId}`);
//             await update(doctorAppointmentRef, updates);

//             if (appointment.patientID) {
//                 const patientAppointmentRef = ref(database, `users/${appointment.patientID}/appointments/${appointmentId}`);
//                 await update(patientAppointmentRef, updates);
//             }

//             toast.success('Appointment marked as completed');
//             fetchAppointmentDetails(); // Refresh data
//         } catch (error) {
//             console.error('Error completing appointment:', error);
//             toast.error('Failed to complete appointment');
//         }
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return 'N/A';
//         if (dateString.includes('/')) return dateString;
        
//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) return dateString;
//             return date.toLocaleDateString('en-US', {
//                 weekday: 'long',
//                 year: 'numeric',
//                 month: 'long',
//                 day: 'numeric'
//             });
//         } catch (error) {
//             return dateString;
//         }
//     };

//     const formatDateTime = (dateString) => {
//         if (!dateString) return 'N/A';
//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) return dateString;
//             return date.toLocaleString('en-US', {
//                 year: 'numeric',
//                 month: 'short',
//                 day: 'numeric',
//                 hour: '2-digit',
//                 minute: '2-digit'
//             });
//         } catch (error) {
//             return dateString;
//         }
//     };

//     const printPrescription = () => {
//         const printWindow = window.open('', '_blank');
//         const prescriptionHTML = `
//             <!DOCTYPE html>
//             <html>
//             <head>
//                 <title>Medical Prescription - ${appointment.patientName}</title>
//                 <style>
//                     body {
//                         font-family: 'Arial', sans-serif;
//                         margin: 0;
//                         padding: 20px;
//                         background: white;
//                     }
//                     .prescription-container {
//                         max-width: 800px;
//                         margin: 0 auto;
//                         border: 3px solid #1976d2;
//                         padding: 30px;
//                         background: white;
//                     }
//                     .header {
//                         text-align: center;
//                         border-bottom: 3px solid #1976d2;
//                         padding-bottom: 20px;
//                         margin-bottom: 30px;
//                     }
//                     .header h1 {
//                         color: #1976d2;
//                         margin: 0;
//                         font-size: 32px;
//                         font-weight: bold;
//                     }
//                     .header h2 {
//                         color: #333;
//                         margin: 5px 0;
//                         font-size: 20px;
//                     }
//                     .clinic-info {
//                         color: #666;
//                         margin-top: 10px;
//                         font-size: 14px;
//                     }
//                     .section {
//                         margin: 20px 0;
//                         padding: 15px;
//                         background: #f8f9fa;
//                         border-left: 4px solid #1976d2;
//                     }
//                     .section-title {
//                         color: #1976d2;
//                         font-weight: bold;
//                         font-size: 16px;
//                         margin-bottom: 10px;
//                         text-transform: uppercase;
//                     }
//                     .info-row {
//                         display: flex;
//                         justify-content: space-between;
//                         padding: 8px 0;
//                         border-bottom: 1px solid #e0e0e0;
//                     }
//                     .info-row:last-child {
//                         border-bottom: none;
//                     }
//                     .label {
//                         font-weight: 600;
//                         color: #555;
//                     }
//                     .value {
//                         color: #333;
//                     }
//                     .prescription-box {
//                         background: white;
//                         border: 2px solid #1976d2;
//                         padding: 20px;
//                         min-height: 200px;
//                         margin: 20px 0;
//                         white-space: pre-wrap;
//                         font-family: 'Courier New', monospace;
//                         font-size: 13px;
//                     }
//                     .footer {
//                         margin-top: 40px;
//                         padding-top: 20px;
//                         border-top: 2px solid #1976d2;
//                         text-align: right;
//                     }
//                     .signature {
//                         margin-top: 50px;
//                         text-align: right;
//                     }
//                     .signature-line {
//                         border-top: 2px solid #333;
//                         width: 250px;
//                         margin-left: auto;
//                         padding-top: 10px;
//                         text-align: center;
//                         font-weight: bold;
//                     }
//                     @media print {
//                         body {
//                             padding: 0;
//                         }
//                         .prescription-container {
//                             border: none;
//                         }
//                     }
//                 </style>
//             </head>
//             <body>
//                 <div class="prescription-container">
//                     <div class="header">
//                         <h1>🏥 MEDICAL PRESCRIPTION</h1>
//                         <h2>${appointment.doctorName || 'Doctor'}</h2>
//                         <div class="clinic-info">
//                             ${appointment.clinicName || "Doctor's Clinic"}<br>
//                             Date: ${formatDate(new Date().toISOString())}
//                         </div>
//                     </div>

//                     <div class="section">
//                         <div class="section-title">👤 Patient Information</div>
//                         <div class="info-row">
//                             <span class="label">Patient Name:</span>
//                             <span class="value">${appointment.patientName || 'Not provided'}</span>
//                         </div>
//                         <div class="info-row">
//                             <span class="label">Age:</span>
//                             <span class="value">${appointment.patientAge || 'N/A'} years</span>
//                         </div>
//                         <div class="info-row">
//                             <span class="label">Contact:</span>
//                             <span class="value">${appointment.patientPhone || 'Not provided'}</span>
//                         </div>
//                         <div class="info-row">
//                             <span class="label">Email:</span>
//                             <span class="value">${appointment.patientEmail || 'Not provided'}</span>
//                         </div>
//                     </div>

//                     <div class="section">
//                         <div class="section-title">📅 Appointment Details</div>
//                         <div class="info-row">
//                             <span class="label">Appointment Date:</span>
//                             <span class="value">${formatDate(appointment.date)}</span>
//                         </div>
//                         <div class="info-row">
//                             <span class="label">Time:</span>
//                             <span class="value">${appointment.timeSlot || 'Not specified'}</span>
//                         </div>
//                         <div class="info-row">
//                             <span class="label">Appointment ID:</span>
//                             <span class="value">${appointment.appointmentId || appointmentId}</span>
//                         </div>
//                     </div>

//                     <div class="section">
//                         <div class="section-title">🏥 Chief Complaints / Symptoms</div>
//                         <div style="padding: 10px; background: white; border-radius: 5px;">
//                             ${appointment.healthIssues || appointment.description || 'Not provided'}
//                         </div>
//                     </div>

//                     <div class="section">
//                         <div class="section-title">📋 Medical History</div>
//                         <div style="padding: 10px; background: white; border-radius: 5px;">
//                             ${appointment.medicalHistory || 'None provided'}
//                         </div>
//                     </div>

//                     <div class="section">
//                         <div class="section-title">💊 Current Medications</div>
//                         <div style="padding: 10px; background: white; border-radius: 5px;">
//                             ${appointment.currentMedications || 'None'}
//                         </div>
//                     </div>

//                     <div style="margin: 30px 0;">
//                         <div class="section-title" style="color: #1976d2; font-size: 18px; margin-bottom: 15px;">
//                             ℞ PRESCRIPTION
//                         </div>
//                         <div class="prescription-box">
// ${prescription || 'No prescription provided'}
//                         </div>
//                     </div>

//                     <div class="footer">
//                         <div><strong>Prescription Date:</strong> ${formatDateTime(appointment.prescriptionDate || new Date().toISOString())}</div>
//                     </div>

//                     <div class="signature">
//                         <div class="signature-line">
//                             ${appointment.doctorName || 'Doctor'}<br>
//                             <span style="font-size: 12px; color: #666;">Doctor's Signature</span>
//                         </div>
//                     </div>
//                 </div>
//             </body>
//             </html>
//         `;
        
//         printWindow.document.write(prescriptionHTML);
//         printWindow.document.close();
//         printWindow.focus();
//         setTimeout(() => {
//             printWindow.print();
//         }, 250);
//     };

//     if (loading) {
//         return (
//             <Box sx={{ textAlign: 'center', py: 4 }}>
//                 <Typography variant="h6" sx={{ color: '#1976d2' }}>
//                     Loading appointment details...
//                 </Typography>
//             </Box>
//         );
//     }

//     if (!appointment) {
//         return (
//             <Alert severity="error">
//                 Appointment not found
//             </Alert>
//         );
//     }

//     return (
//         <Box sx={{ backgroundColor: '#f5f5f5', p: 3, borderRadius: '12px' }}>
//             {/* Header */}
//             <Box sx={{ mb: 3 }}>
//                 <Typography variant="h4" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 1 }}>
//                     📋 Appointment Details
//                 </Typography>
//                 <Typography variant="body2" color="textSecondary">
//                     ID: {appointment.appointmentId || appointmentId}
//                 </Typography>
//                 <Chip 
//                     label={appointment.status || 'Pending'} 
//                     color={
//                         appointment.status === 'Completed' ? 'success' :
//                         appointment.status === 'Confirmed' ? 'primary' :
//                         appointment.status === 'Cancelled' ? 'error' : 'warning'
//                     }
//                     sx={{ mt: 1 }}
//                 />
//             </Box>

//             <Grid container spacing={3}>
//                 {/* Patient Information */}
//                 <Grid item xs={12} md={6}>
//                     <Card sx={{ border: '2px solid #1976d2', borderRadius: '12px' }}>
//                         <CardContent sx={{ backgroundColor: '#1976d2', color: 'white' }}>
//                             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                                 👤 Patient Information
//                             </Typography>
//                         </CardContent>
//                         <CardContent>
//                             <InfoRow label="Full Name" value={appointment.patientName || 'Not provided'} bold />
//                             <InfoRow label="Age" value={`${appointment.patientAge || 'N/A'} ${appointment.patientAge ? 'years' : ''}`} />
//                             <InfoRow label="Mobile" value={`📱 ${appointment.patientPhone || appointment.patientMobile || 'Not provided'}`} />
//                             <InfoRow label="Email" value={`📧 ${appointment.patientEmail || 'Not provided'}`} />
//                             <InfoRow label="Patient ID" value={appointment.patientID || 'N/A'} code />
//                         </CardContent>
//                     </Card>
//                 </Grid>

//                 {/* Appointment Schedule */}
//                 <Grid item xs={12} md={6}>
//                     <Card sx={{ border: '2px solid #0288d1', borderRadius: '12px' }}>
//                         <CardContent sx={{ backgroundColor: '#0288d1', color: 'white' }}>
//                             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                                 📅 Appointment Schedule
//                             </Typography>
//                         </CardContent>
//                         <CardContent>
//                             <InfoRow label="Date" value={formatDate(appointment.date)} bold />
//                             <InfoRow label="Time Slot" value={`🕐 ${appointment.timeSlot || 'Not specified'}`} />
//                             <InfoRow label="Booking Date" value={formatDateTime(appointment.bookingDate || appointment.createdAt)} />
//                             <InfoRow label="Payment Status" value={appointment.paymentStatus || 'Pending'} chip />
//                         </CardContent>
//                     </Card>
//                 </Grid>

//                 {/* Health Information */}
//                 <Grid item xs={12}>
//                     <Card sx={{ border: '2px solid #e53935', borderRadius: '12px' }}>
//                         <CardContent sx={{ backgroundColor: '#e53935', color: 'white' }}>
//                             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                                 🏥 Health Information
//                             </Typography>
//                         </CardContent>
//                         <CardContent>
//                             <Box sx={{ mb: 2 }}>
//                                 <Typography variant="subtitle2" sx={{ color: '#e53935', fontWeight: 'bold', mb: 1 }}>
//                                     Current Health Issues / Symptoms:
//                                 </Typography>
//                                 <Paper sx={{ p: 2, backgroundColor: '#fff3e0', border: '1px solid #ffb74d' }}>
//                                     <Typography variant="body2">
//                                         {appointment.healthIssues || appointment.description || 'Not provided'}
//                                     </Typography>
//                                 </Paper>
//                             </Box>

//                             <Box sx={{ mb: 2 }}>
//                                 <Typography variant="subtitle2" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 1 }}>
//                                     Medical History:
//                                 </Typography>
//                                 <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', border: '1px solid #64b5f6' }}>
//                                     <Typography variant="body2">
//                                         {appointment.medicalHistory || 'None provided'}
//                                     </Typography>
//                                 </Paper>
//                             </Box>

//                             <Box>
//                                 <Typography variant="subtitle2" sx={{ color: '#00897b', fontWeight: 'bold', mb: 1 }}>
//                                     Current Medications:
//                                 </Typography>
//                                 <Paper sx={{ p: 2, backgroundColor: '#e0f2f1', border: '1px solid #4db6ac' }}>
//                                     <Typography variant="body2">
//                                         {appointment.currentMedications || 'None provided'}
//                                     </Typography>
//                                 </Paper>
//                             </Box>
//                         </CardContent>
//                     </Card>
//                 </Grid>

//                 {/* Prescription */}
//                 <Grid item xs={12}>
//                     <Card sx={{ border: '3px solid #1976d2', borderRadius: '12px' }}>
//                         <CardContent sx={{ backgroundColor: '#1976d2', color: 'white' }}>
//                             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                                 ℞ Doctor's Prescription & Treatment Plan
//                             </Typography>
//                         </CardContent>
//                         <CardContent sx={{ p: 3 }}>
//                             <TextField
//                                 fullWidth
//                                 multiline
//                                 rows={15}
//                                 variant="outlined"
//                                 label="Enter detailed prescription, diagnosis, and treatment plan"
//                                 value={prescription}
//                                 onChange={(e) => setPrescription(e.target.value)}
//                                 placeholder={`Enter comprehensive prescription including:

// DIAGNOSIS:
// • Primary diagnosis
// • Differential diagnosis (if any)

// MEDICATIONS:
// • Medicine name - Dosage - Frequency - Duration
// • Example: Paracetamol 500mg - 1 tablet - 3 times daily - 5 days

// LABORATORY TESTS:
// • List any required blood tests, X-rays, or other investigations

// DIET & LIFESTYLE:
// • Dietary recommendations
// • Exercise or activity restrictions
// • Lifestyle modifications

// FOLLOW-UP:
// • Next appointment date
// • When to seek immediate care
// • Expected recovery time

// SPECIAL INSTRUCTIONS:
// • Any other important notes for the patient`}
//                                 sx={{
//                                     '& .MuiOutlinedInput-root': {
//                                         fontFamily: 'monospace',
//                                         fontSize: '14px',
//                                         '&.Mui-focused fieldset': {
//                                             borderColor: '#1976d2',
//                                             borderWidth: '2px'
//                                         }
//                                     }
//                                 }}
//                             />

//                             <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
//                                 <Button
//                                     variant="contained"
//                                     onClick={handleSavePrescription}
//                                     disabled={savingPrescription || !prescription.trim()}
//                                     sx={{ 
//                                         backgroundColor: '#1976d2',
//                                         fontWeight: 'bold',
//                                         '&:hover': { backgroundColor: '#1565c0' }
//                                     }}
//                                 >
//                                     {savingPrescription ? 'Saving...' : '💾 Save Prescription'}
//                                 </Button>

//                                 <Button
//                                     variant="contained"
//                                     color="success"
//                                     onClick={handleCompleteAppointment}
//                                     disabled={!prescription.trim() || appointment.status === 'Completed'}
//                                     sx={{ fontWeight: 'bold' }}
//                                 >
//                                     ✅ Complete Appointment
//                                 </Button>

//                                 {prescription.trim() && (
//                                     <Button
//                                         variant="contained"
//                                         color="info"
//                                         onClick={printPrescription}
//                                         sx={{ fontWeight: 'bold' }}
//                                     >
//                                         🖨️ Print Prescription
//                                     </Button>
//                                 )}
//                             </Box>

//                             {appointment.prescriptionDate && (
//                                 <Alert severity="info" sx={{ mt: 2 }}>
//                                     <strong>📅 Last updated:</strong> {formatDateTime(appointment.prescriptionDate)}
//                                 </Alert>
//                             )}

//                             {appointment.completedAt && (
//                                 <Alert severity="success" sx={{ mt: 2 }}>
//                                     <strong>✅ Completed on:</strong> {formatDateTime(appointment.completedAt)}
//                                 </Alert>
//                             )}
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             </Grid>
//         </Box>
//     );
// };

// // Helper component for consistent info rows
// const InfoRow = ({ label, value, bold, code, chip }) => (
//     <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         py: 1.5, 
//         borderBottom: '1px solid #e0e0e0' 
//     }}>
//         <Typography variant="body2" sx={{ fontWeight: 600, color: '#666' }}>
//             {label}:
//         </Typography>
//         {chip ? (
//             <Chip 
//                 label={value} 
//                 size="small" 
//                 color={value?.toLowerCase() === 'pending' ? 'warning' : 'success'} 
//             />
//         ) : code ? (
//             <Typography 
//                 variant="body2" 
//                 component="code" 
//                 sx={{ 
//                     backgroundColor: '#e3f2fd', 
//                     padding: '4px 8px', 
//                     borderRadius: '4px' 
//                 }}
//             >
//                 {value}
//             </Typography>
//         ) : (
//             <Typography 
//                 variant="body2" 
//                 sx={{ 
//                     fontWeight: bold ? 'bold' : 'normal',
//                     color: bold ? '#1976d2' : 'inherit'
//                 }}
//             >
//                 {value}
//             </Typography>
//         )}
//     </Box>
// );

// export default PatientDetails;


import React, { useState, useEffect } from 'react';
import { getDatabase, ref, get, update } from 'firebase/database';
import { 
    Box, 
    Paper, 
    Typography, 
    Grid, 
    Card, 
    CardContent, 
    TextField, 
    Button, 
    Divider,
    Chip,
    Alert,
    useTheme,
    useMediaQuery,
    Container,
    CircularProgress,
    Stack,
    IconButton
} from '@mui/material';
import { toast } from 'react-toastify';
import PrintIcon from '@mui/icons-material/Print';
import SaveIcon from '@mui/icons-material/Save';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const database = getDatabase();

const PatientDetails = ({ appointmentId, doctorId, onBack }) => {
    const [appointment, setAppointment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [prescription, setPrescription] = useState('');
    const [savingPrescription, setSavingPrescription] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        fetchAppointmentDetails();
    }, [appointmentId, doctorId]);

    const fetchAppointmentDetails = async () => {
        try {
            setLoading(true);
            const appointmentRef = ref(database, `doctor/${doctorId}/appointments/${appointmentId}`);
            const snapshot = await get(appointmentRef);

            if (snapshot.exists()) {
                const appointmentData = snapshot.val();
                setAppointment(appointmentData);
                setPrescription(appointmentData.prescription || '');
            } else {
                toast.error('Appointment not found');
            }
        } catch (error) {
            console.error('Error fetching appointment:', error);
            toast.error('Failed to load appointment details');
        } finally {
            setLoading(false);
        }
    };

    const handleSavePrescription = async () => {
        if (!prescription.trim()) {
            toast.error('Please enter prescription details');
            return;
        }

        setSavingPrescription(true);
        try {
            const updates = {
                prescription: prescription.trim(),
                prescriptionDate: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            };

            const doctorAppointmentRef = ref(database, `doctor/${doctorId}/appointments/${appointmentId}`);
            await update(doctorAppointmentRef, updates);

            if (appointment.patientID) {
                const patientAppointmentRef = ref(database, `users/${appointment.patientID}/appointments/${appointmentId}`);
                await update(patientAppointmentRef, updates);
            }

            toast.success('Prescription saved successfully');
            setAppointment(prev => ({ ...prev, ...updates }));
        } catch (error) {
            console.error('Error saving prescription:', error);
            toast.error('Failed to save prescription');
        } finally {
            setSavingPrescription(false);
        }
    };

    const handleCompleteAppointment = async () => {
        if (!prescription.trim()) {
            toast.error('Please add prescription before completing appointment');
            return;
        }

        try {
            const updates = {
                status: 'Completed',
                completedAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            };

            const doctorAppointmentRef = ref(database, `doctor/${doctorId}/appointments/${appointmentId}`);
            await update(doctorAppointmentRef, updates);

            if (appointment.patientID) {
                const patientAppointmentRef = ref(database, `users/${appointment.patientID}/appointments/${appointmentId}`);
                await update(patientAppointmentRef, updates);
            }

            toast.success('Appointment marked as completed');
            fetchAppointmentDetails();
        } catch (error) {
            console.error('Error completing appointment:', error);
            toast.error('Failed to complete appointment');
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        if (dateString.includes('/')) return dateString;
        
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return date.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch (error) {
            return dateString;
        }
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (error) {
            return dateString;
        }
    };

    const printPrescription = () => {
        const printWindow = window.open('', '_blank');
        const prescriptionHTML = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Medical Prescription - ${appointment.patientName}</title>
                <style>
                    body { font-family: 'Arial', sans-serif; margin: 0; padding: 20px; }
                    .prescription-container { max-width: 800px; margin: 0 auto; border: 3px solid #1976d2; padding: 30px; }
                    .header { text-align: center; border-bottom: 3px solid #1976d2; padding-bottom: 20px; margin-bottom: 30px; }
                    .header h1 { color: #1976d2; margin: 0; font-size: 32px; }
                    .section { margin: 20px 0; padding: 15px; background: #f8f9fa; border-left: 4px solid #1976d2; }
                    .section-title { color: #1976d2; font-weight: bold; font-size: 16px; margin-bottom: 10px; }
                    .info-row { display: flex; justify-content: space-between; padding: 8px 0; }
                    .prescription-box { border: 2px solid #1976d2; padding: 20px; min-height: 200px; margin: 20px 0; white-space: pre-wrap; }
                    @media print { body { padding: 0; } .prescription-container { border: none; } }
                </style>
            </head>
            <body>
                <div class="prescription-container">
                    <div class="header">
                        <h1>🏥 MEDICAL PRESCRIPTION</h1>
                        <h2>${appointment.doctorName || 'Doctor'}</h2>
                        <div>${appointment.clinicName || "Doctor's Clinic"}<br>Date: ${formatDate(new Date().toISOString())}</div>
                    </div>
                    <div class="section">
                        <div class="section-title">👤 Patient Information</div>
                        <div class="info-row"><span>Patient Name:</span><span>${appointment.patientName || 'Not provided'}</span></div>
                        <div class="info-row"><span>Age:</span><span>${appointment.patientAge || 'N/A'} years</span></div>
                        <div class="info-row"><span>Contact:</span><span>${appointment.patientPhone || 'Not provided'}</span></div>
                    </div>
                    <div class="section">
                        <div class="section-title">📅 Appointment Details</div>
                        <div class="info-row"><span>Date:</span><span>${formatDate(appointment.date)}</span></div>
                        <div class="info-row"><span>Time:</span><span>${appointment.timeSlot || 'Not specified'}</span></div>
                    </div>
                    <div style="margin: 30px 0;">
                        <div class="section-title">℞ PRESCRIPTION</div>
                        <div class="prescription-box">${prescription || 'No prescription provided'}</div>
                    </div>
                    <div style="text-align: right; margin-top: 40px;">
                        <div style="border-top: 2px solid #333; width: 250px; margin-left: auto; padding-top: 10px; text-align: center;">
                            ${appointment.doctorName || 'Doctor'}<br>
                            <span style="font-size: 12px; color: #666;">Doctor's Signature</span>
                        </div>
                    </div>
                </div>
            </body>
            </html>
        `;
        
        printWindow.document.write(prescriptionHTML);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
        }, 250);
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!appointment) {
        return (
            <Alert severity="error" sx={{ m: 2 }}>
                Appointment not found
            </Alert>
        );
    }

    return (
        <Container maxWidth="xl" sx={{ py: { xs: 1, sm: 2, md: 3 } }}>
            {/* Back Button - Mobile Only */}
            {isMobile && onBack && (
                <IconButton 
                    onClick={onBack}
                    sx={{ mb: 2 }}
                >
                    <ArrowBackIcon />
                </IconButton>
            )}

            {/* Header */}
            <Box sx={{ 
                mb: { xs: 2, sm: 3 }, 
                p: { xs: 1, sm: 2 }, 
                backgroundColor: '#f5f5f5', 
                borderRadius: 2 
            }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <Box>
                        <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                            📋 Appointment Details
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            ID: {appointment.appointmentId || appointmentId}
                        </Typography>
                    </Box>
                    <Chip 
                        label={appointment.status || 'Pending'} 
                        color={
                            appointment.status === 'Completed' ? 'success' :
                            appointment.status === 'Confirmed' ? 'primary' :
                            appointment.status === 'Cancelled' ? 'error' : 'warning'
                        }
                        sx={{ mt: { xs: 1, sm: 0 } }}
                    />
                </Box>
            </Box>

            <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                {/* Patient Information */}
                <Grid item xs={12} md={6}>
                    <Card sx={{ 
                        height: '100%',
                        border: '2px solid #1976d2', 
                        borderRadius: 2,
                        transition: 'transform 0.2s',
                        '&:hover': { transform: 'translateY(-4px)' }
                    }}>
                        <CardContent sx={{ 
                            backgroundColor: '#1976d2', 
                            color: 'white',
                            py: { xs: 1, sm: 2 }
                        }}>
                            <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ fontWeight: 'bold' }}>
                                👤 Patient Information
                            </Typography>
                        </CardContent>
                        <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                            <InfoRow label="Full Name" value={appointment.patientName || 'Not provided'} bold />
                            <InfoRow label="Age" value={`${appointment.patientAge || 'N/A'} ${appointment.patientAge ? 'years' : ''}`} />
                            <InfoRow label="Mobile" value={`📱 ${appointment.patientPhone || appointment.patientMobile || 'Not provided'}`} />
                            <InfoRow label="Email" value={`📧 ${appointment.patientEmail || 'Not provided'}`} />
                            <InfoRow label="Patient ID" value={appointment.patientID || 'N/A'} code />
                        </CardContent>
                    </Card>
                </Grid>

                {/* Appointment Schedule */}
                <Grid item xs={12} md={6}>
                    <Card sx={{ 
                        height: '100%',
                        border: '2px solid #0288d1', 
                        borderRadius: 2,
                        transition: 'transform 0.2s',
                        '&:hover': { transform: 'translateY(-4px)' }
                    }}>
                        <CardContent sx={{ 
                            backgroundColor: '#0288d1', 
                            color: 'white',
                            py: { xs: 1, sm: 2 }
                        }}>
                            <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ fontWeight: 'bold' }}>
                                📅 Appointment Schedule
                            </Typography>
                        </CardContent>
                        <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                            <InfoRow label="Date" value={formatDate(appointment.date)} bold />
                            <InfoRow label="Time Slot" value={`🕐 ${appointment.timeSlot || 'Not specified'}`} />
                            <InfoRow label="Booking Date" value={formatDateTime(appointment.bookingDate || appointment.createdAt)} />
                            <InfoRow label="Payment Status" value={appointment.paymentStatus || 'Pending'} chip />
                        </CardContent>
                    </Card>
                </Grid>

                {/* Health Information */}
                <Grid item xs={12}>
                    <Card sx={{ 
                        border: '2px solid #e53935', 
                        borderRadius: 2,
                        transition: 'transform 0.2s',
                        '&:hover': { transform: 'translateY(-4px)' }
                    }}>
                        <CardContent sx={{ 
                            backgroundColor: '#e53935', 
                            color: 'white',
                            py: { xs: 1, sm: 2 }
                        }}>
                            <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ fontWeight: 'bold' }}>
                                🏥 Health Information
                            </Typography>
                        </CardContent>
                        <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ color: '#e53935', fontWeight: 'bold', mb: 1 }}>
                                    Current Health Issues / Symptoms:
                                </Typography>
                                <Paper sx={{ 
                                    p: { xs: 1, sm: 2 }, 
                                    backgroundColor: '#fff3e0', 
                                    border: '1px solid #ffb74d',
                                    fontSize: { xs: '0.875rem', sm: '1rem' }
                                }}>
                                    {appointment.healthIssues || appointment.description || 'Not provided'}
                                </Paper>
                            </Box>

                            <Grid container spacing={{ xs: 1, sm: 2 }}>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ mb: { xs: 1, sm: 2 } }}>
                                        <Typography variant="subtitle2" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 1 }}>
                                            Medical History:
                                        </Typography>
                                        <Paper sx={{ 
                                            p: { xs: 1, sm: 2 }, 
                                            backgroundColor: '#e3f2fd', 
                                            border: '1px solid #64b5f6',
                                            minHeight: '80px',
                                            fontSize: { xs: '0.875rem', sm: '1rem' }
                                        }}>
                                            {appointment.medicalHistory || 'None provided'}
                                        </Paper>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box>
                                        <Typography variant="subtitle2" sx={{ color: '#00897b', fontWeight: 'bold', mb: 1 }}>
                                            Current Medications:
                                        </Typography>
                                        <Paper sx={{ 
                                            p: { xs: 1, sm: 2 }, 
                                            backgroundColor: '#e0f2f1', 
                                            border: '1px solid #4db6ac',
                                            minHeight: '80px',
                                            fontSize: { xs: '0.875rem', sm: '1rem' }
                                        }}>
                                            {appointment.currentMedications || 'None provided'}
                                        </Paper>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Prescription */}
                <Grid item xs={12}>
                    <Card sx={{ 
                        border: '3px solid #1976d2', 
                        borderRadius: 2,
                        transition: 'transform 0.2s',
                        '&:hover': { transform: 'translateY(-4px)' }
                    }}>
                        <CardContent sx={{ 
                            backgroundColor: '#1976d2', 
                            color: 'white',
                            py: { xs: 1, sm: 2 }
                        }}>
                            <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ fontWeight: 'bold' }}>
                                ℞ Doctor's Prescription & Treatment Plan
                            </Typography>
                        </CardContent>
                        <CardContent sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
                            <TextField
                                fullWidth
                                multiline
                                rows={isMobile ? 8 : isTablet ? 10 : 12}
                                variant="outlined"
                                label="Enter detailed prescription, diagnosis, and treatment plan"
                                value={prescription}
                                onChange={(e) => setPrescription(e.target.value)}
                                placeholder={`Enter comprehensive prescription including:

DIAGNOSIS:
• Primary diagnosis
• Differential diagnosis (if any)

MEDICATIONS:
• Medicine name - Dosage - Frequency - Duration
• Example: Paracetamol 500mg - 1 tablet - 3 times daily - 5 days

LABORATORY TESTS:
• List any required blood tests, X-rays, or other investigations

DIET & LIFESTYLE:
• Dietary recommendations
• Exercise or activity restrictions
• Lifestyle modifications

FOLLOW-UP:
• Next appointment date
• When to seek immediate care
• Expected recovery time

SPECIAL INSTRUCTIONS:
• Any other important notes for the patient`}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        fontFamily: 'monospace',
                                        fontSize: { xs: '0.875rem', sm: '0.9rem', md: '1rem' },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#1976d2',
                                            borderWidth: '2px'
                                        }
                                    }
                                }}
                            />

                            <Stack 
                                direction={{ xs: 'column', sm: 'row' }} 
                                spacing={1.5} 
                                sx={{ mt: 2, flexWrap: 'wrap' }}
                            >
                                <Button
                                    variant="contained"
                                    startIcon={<SaveIcon />}
                                    onClick={handleSavePrescription}
                                    disabled={savingPrescription || !prescription.trim()}
                                    sx={{ 
                                        backgroundColor: '#1976d2',
                                        fontWeight: 'bold',
                                        flex: { xs: '1', sm: '0' },
                                        minWidth: { xs: '100%', sm: 'auto' }
                                    }}
                                >
                                    {savingPrescription ? 'Saving...' : 'Save Prescription'}
                                </Button>

                                <Button
                                    variant="contained"
                                    color="success"
                                    startIcon={<CheckCircleIcon />}
                                    onClick={handleCompleteAppointment}
                                    disabled={!prescription.trim() || appointment.status === 'Completed'}
                                    sx={{ 
                                        fontWeight: 'bold',
                                        flex: { xs: '1', sm: '0' },
                                        minWidth: { xs: '100%', sm: 'auto' }
                                    }}
                                >
                                    Complete Appointment
                                </Button>

                                {prescription.trim() && (
                                    <Button
                                        variant="contained"
                                        color="info"
                                        startIcon={<PrintIcon />}
                                        onClick={printPrescription}
                                        sx={{ 
                                            fontWeight: 'bold',
                                            flex: { xs: '1', sm: '0' },
                                            minWidth: { xs: '100%', sm: 'auto' }
                                        }}
                                    >
                                        Print Prescription
                                    </Button>
                                )}
                            </Stack>

                            {appointment.prescriptionDate && (
                                <Alert severity="info" sx={{ mt: 2, fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                                    <strong>📅 Last updated:</strong> {formatDateTime(appointment.prescriptionDate)}
                                </Alert>
                            )}

                            {appointment.completedAt && (
                                <Alert severity="success" sx={{ mt: 2, fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                                    <strong>✅ Completed on:</strong> {formatDateTime(appointment.completedAt)}
                                </Alert>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

// Helper component for consistent info rows
const InfoRow = ({ label, value, bold, code, chip }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between', 
            py: 1,
            borderBottom: '1px solid #e0e0e0',
            gap: { xs: 0.5, sm: 0 }
        }}>
            <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: '#666',
                fontSize: { xs: '0.875rem', sm: '1rem' }
            }}>
                {label}:
            </Typography>
            {chip ? (
                <Chip 
                    label={value} 
                    size="small" 
                    color={value?.toLowerCase() === 'pending' ? 'warning' : 'success'} 
                    sx={{ mt: { xs: 0.5, sm: 0 } }}
                />
            ) : code ? (
                <Typography 
                    variant="body2" 
                    component="code" 
                    sx={{ 
                        backgroundColor: '#e3f2fd', 
                        padding: '2px 6px', 
                        borderRadius: '4px',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        mt: { xs: 0.5, sm: 0 }
                    }}
                >
                    {value}
                </Typography>
            ) : (
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontWeight: bold ? 'bold' : 'normal',
                        color: bold ? '#1976d2' : 'inherit',
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        textAlign: { xs: 'left', sm: 'right' },
                        mt: { xs: 0.5, sm: 0 }
                    }}
                >
                    {value}
                </Typography>
            )}
        </Box>
    );
};

export default PatientDetails;